import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PricingRuleAction } from '../pricingRule.action';

export const reloadPricingRuleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PricingRuleAction.reload,
    PricingRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      PricingRuleAction.loadList.started(),
    ];
  }),
);
